import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import configureStore, { history } from './store';
const { persistor, store } = configureStore();

window.VULOG_TRANSLATIONS = {};
window.VULOG_LINKS = {};
window.VULOG_TRANSLATE = s => {
    return window.VULOG_TRANSLATIONS[s] || s;
};

window.SET_VULOG_DATA = d => {
    const parser = new DOMParser();
    Object.keys(d.LANGUAGE).forEach(entry => {
        if (d.LANGUAGE[entry]) {
            d.LANGUAGE[entry] = parser.parseFromString(d.LANGUAGE[entry], 'text/html').body.textContent;
        }
    });

    window.VULOG_TRANSLATIONS = {
        ...d.LANGUAGE,
        loaded: true,
    };

    window.VULOG_CONFIG = d;
    window.VULOG_ENABLE_PROMOCODE = d.ENABLE_PROMOCODE;
    window.VULOG_LOCALE = d.LOCALE;

    window.VULOG_PHONE_NUMBER_COUNTRY = d.PHONE_NUMBER_COUNTRY;

    window.VULOG_SMS_REQUIRED = d.SMS_REQUIRED;

    window.VULOG_IDENTITY_REQUIRED = d.IDENTITY_REQUIRED;

    if (d.title) {
        if (document.title !== d.TITLE) {
            document.title = d.TITLE;
        }
    }

    /* eslint-disable */
    if (!window.VULOG_GTM) {
        if (d.GTM) {
            window.VULOG_GTM = d.GTM;
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',d.GTM);
        }
    }


    if (!window.VULOG_GTM_MAIN) {
        if (d.GTM_MAIN) {
            window.VULOG_GTM_MAIN = d.GTM_MAIN;
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',d.GTM_MAIN);
        }
    }
    
    if (!window.VULOG_EXTERNAL_CSS && window.VULOG_CONFIG.CSS) {
        window.VULOG_EXTERNAL_CSS = true;

        const link = document.createElement('link');
        link.href = `data:text/css;base64,${btoa(window.VULOG_CONFIG.CSS)}`;
        link.type = 'text/css';
        link.rel = 'stylesheet';
        document.head.insertBefore( link, document.head.childNodes[ document.head.childNodes.length - 1 ].nextSibling );
    }
}

ReactDOM.render(
    <App routerHistory={history} store={store} persistor={persistor} />,
    document.getElementById('root')
);
